export const formInfo = {
  fieldList: [
    {
      label: '开始时间',
      value: 'start_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'startTimeChange',
    },
    {
      label: '结束时间',
      value: 'end_time',
      dateType: 'date',
      required: true,
      type: 'date',
      event: 'startTimeChange',
    },
    {
      label: '统计周期',
      value: 'time_type',
      type: 'select',
      list: 'cycle',
    },
    {
      label: '供应商',
      type: 'select',
      value: 'outsourcer',
      list: 'opr',
    },
    {
      label: '产线',
      type: 'select',
      value: 'production_line_id',
      list: 'proline',
    },
    {
      type: 'slot',
      value: 'submit',
    },
  ],
  data: {
    start_time: (function () {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      return date;
    }()),
    end_time: new Date(),
    time_type: '天',
    outsourcer: 0,
    production_line_id: 0,
  },
  listTypeInfo: {
    cycle: [
      {
        key: '天',
        value: '天',
      },
      {
        key: '自然周',
        value: '周',
      },
      {
        key: '汇报周',
        value: '汇报周',
      },
      {
        key: '自然月',
        value: '月',
      },
      {
        key: '结算月',
        value: '结算月',
      },
    ],
    proline: [ // 产线
      {
        key: '全部',
        value: 0,
      },
    ],
    opr: [ // 供应商
      {
        key: '全部',
        value: 0,
      },
    ],
  },

};

// 各供应商整体达标率折线图
export const outConfig = {
  option: {},
  load: false,
  clear: false,
};
// 各产线整体达标率折线图
export const proLineConfig = {
  option: {},
  load: false,
  clear: false,
};

export const table = {
  tableColumn: [
    {
      prop: 'date',
      label: '日期',
    },
    {
      prop: 'production_line',
      label: '产线',
    },
    {
      prop: 'outsourcer',
      label: '供应商',
    },
    {
      prop: 'pass_rate',
      label: '整体达标率',
    },
    {
      prop: 'pass_count',
      label: '达标人数',
    },
    {
      prop: 'rational',
      label: '未达标内部合理人数',
    },
    {
      prop: 'total',
      label: '出勤人数',
    },
  ],
  data: [],
  pageSize: 10,
  pageNo: 1,
  totalCount: 0,
};
